import { GetInspectionTop, PutInspectionTop } from '../../services/apiTypes';
import {
  createHeaderWithCredentials,
  fetchWithAuth,
  getApiUrl,
  getHeader,
} from '../../services/apiUtils';

export interface InspectionTopParams {
  rmaNo: string;
}

const endPoint = 'inspection';
const endPointQc = 'qc';

export const fetchInspectionTop = async (
  params: InspectionTopParams,
): Promise<GetInspectionTop> => {
  const queryParams = new URLSearchParams();
  queryParams.append('rmaNo', params.rmaNo);
  const apiUrl = getApiUrl(endPoint);
  const url = `${apiUrl}?${queryParams.toString()}`;
  const header = getHeader({
    method: 'GET',
  });

  const response = await fetchWithAuth(
    url,
    createHeaderWithCredentials(header),
  );
  return response.data;
};

export const updateInspectionTop = async (
  newInspectionTop: PutInspectionTop,
): Promise<void> => {
  const url = getApiUrl(endPoint);
  const header = getHeader({
    method: 'PUT',
    body: JSON.stringify(newInspectionTop),
    contentType: 'application/json',
  });

  await fetchWithAuth(url, createHeaderWithCredentials(header));
};

export const fetchQcTop = async (
  params: InspectionTopParams,
): Promise<GetInspectionTop> => {
  const queryParams = new URLSearchParams();
  queryParams.append('rmaNo', params.rmaNo);
  const apiUrl = getApiUrl(endPointQc);
  const url = `${apiUrl}?${queryParams.toString()}`;
  const header = getHeader({
    method: 'GET',
  });

  const response = await fetchWithAuth(
    url,
    createHeaderWithCredentials(header),
  );
  return response.data;
};

export const updateQcTop = async (
  newInspectionTop: PutInspectionTop,
): Promise<number> => {
  const url = getApiUrl(endPointQc);
  const header = getHeader({
    method: 'PUT',
    body: JSON.stringify(newInspectionTop),
    contentType: 'application/json',
  });

  const response = await fetchWithAuth(
    url,
    createHeaderWithCredentials(header),
  );

  return response.status;
};
